import styled from '@emotion/styled';

const ManagerWrapper = styled('section')({
  marginBottom: -6,
  display: 'flex',
  flexWrap: 'wrap',
});

export default ManagerWrapper;
